import React from "react"
import { Box, Stack, Typography } from "@mui/material"
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined"
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined"
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined"
import { resolveViraPalette } from "../theme/resolveViraPalette"

export type SourceMetaItem = {
  id: string
  label: string
  icon?: "note" | "mic" | "plan"
}

const ICONS = {
  note: DescriptionOutlinedIcon,
  mic: MicNoneOutlinedIcon,
  plan: AccountTreeOutlinedIcon,
} as const

export type SourceMetaProps = {
  items: SourceMetaItem[]
}

export function SourceMeta({ items }: SourceMetaProps) {
  return (
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
    >
      {items.map((item, index) => {
        const Icon = ICONS[item.icon ?? "note"]
        return (
          <React.Fragment key={item.id}>
            {index > 0 ? (
              <Typography
                sx={(theme) => ({
                  color: resolveViraPalette(theme).subtle,
                  fontSize: 16,
                })}
              >
                ·
              </Typography>
            ) : null}
            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
              <Icon
                sx={(theme) => ({
                  fontSize: 14,
                  color: resolveViraPalette(theme).muted,
                })}
              />
              <Typography
                sx={(theme) => ({
                  fontSize: 12.5,
                  color: resolveViraPalette(theme).muted,
                  lineHeight: 1,
                })}
              >
                {item.label}
              </Typography>
            </Box>
          </React.Fragment>
        )
      })}
    </Stack>
  )
}
